<template>
    <div class="AI">
        <!-- <h2>Настройка вопросов к ИИ</h2> -->
        <router-view/>
    </div>
</template>

<script>

    export default {
        name: 'AI',
        components: {
        },
        props: {
        }, 
        
        data() {
            return {};
        },
        computed:{
        },
        methods: {
        },
        mounted() {
        }
    };
</script>
